import React from 'react';
import './PageHeader.css';

/**
 * Sporty left-border style page header.
 * @param {string} overline  - Small text above the title (e.g. "Formula 1 Prediction Game")
 * @param {string} title     - Main page title (displayed bold, uppercase)
 */
const PageHeader = ({ overline, title }) => (
  <div className="page-header-sporty">
    {overline && <p className="header-overline">{overline}</p>}
    <h1 className="header-main-title">{title}</h1>
  </div>
);

export default PageHeader;
